import React from 'react'
import { Spinner } from 'react-bootstrap'

const SpinnerState = () => {
  return <Spinner animation="border" />
}

export default SpinnerState
